import PaymentsInfo from './PaymentInfo';

export default PaymentsInfo;
